import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanActivateFn,
  GuardResult,
} from '@angular/router';
import { ClientUserService } from 'src/app/services';

export const tokenGuard: CanActivateFn = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Promise<GuardResult> => {
  const userService = inject(ClientUserService);

  const loggedIn = await userService.getUserToken();

  if (loggedIn) {
    await userService.logout();
  }

  // not loggedin, goto /Login
  return true;
};
